import React, { useState } from 'react'
import { IonIcon } from '@ionic/react'
import { closeCircle } from 'ionicons/icons'
import BoxComponent from '../box/Box.component'
import './RolloverBox.component.css'

interface IPageProps {
  color?: string
  content: React.ReactNode
  swipeNextContent?: React.ReactNode
  customStyle?: string
}

interface IRolloverBoxProps {
  pages: IPageProps[]
  swipeBackContent?: React.ReactNode
  size?: { width?: string; height?: string }
  className?: string
}

const RolloverBox: React.FC<IRolloverBoxProps> = ({
  pages,
  swipeBackContent,
  size = { width: '100px', height: '100px' },
  className = '',
}) => {
  const [pageIndex, setPageIndex] = useState(0)
  const [transitionDirection, setTransitionDirection] = useState<'next' | 'prev' | null>(null)

  const totalPages = pages.length
  const currentPage = pages[pageIndex]
  const isLastPage = pageIndex === totalPages - 1

  const nextPage = () => {
    setTransitionDirection('next')
    setPageIndex((prevIndex) => Math.min(prevIndex + 1, totalPages - 1))
  }

  const prevPage = () => {
    setTransitionDirection('prev')
    setPageIndex((prevIndex) => Math.max(prevIndex - 1, 0))
  }

  const handleTransitionEnd = () => {
    setTransitionDirection(null)
  }

  const handleClose = () => {
    setTransitionDirection('prev')
    setPageIndex(0)
  }

  return (
    <BoxComponent
      id='RolloverBox'
      dataTestId='RolloverBox'
      fill={currentPage.color}
      className={`${currentPage.customStyle} ${className} rollover-box`}
      width={size.width}
      height={size.height}>
      {!isLastPage && pageIndex !== 0 && swipeBackContent && (
        <div className='back-button' onClick={prevPage}>
          {swipeBackContent}
        </div>
      )}
      {isLastPage && (
        <div className='rollover-cross-icon' onClick={handleClose}>
          <IonIcon className='close-rollover' icon={closeCircle} color='medium' />
        </div>
      )}
      <div
        className={`rollover-content ${transitionDirection === 'next' ? 'enter' : ''} ${
          transitionDirection === 'prev' ? 'exit' : ''
        }`}
        onAnimationEnd={handleTransitionEnd}>
        {currentPage.content}
        {!isLastPage && (
          <div className={`swipe-next-content ${pageIndex === totalPages - 2 ? 'active' : ''}`} onClick={nextPage}>
            {currentPage.swipeNextContent}
          </div>
        )}
      </div>
    </BoxComponent>
  )
}

export default RolloverBox
